export const defaultColumns = [
  { label: 'Produto', value: 'display_name' },
  { label: 'Quantidade', value: 'quantity' },
  { label: 'Valor Unit.', value: 'unitary_amount' },
  { label: 'Valor total', value: 'amount' },
]
